<script>
import {slugify} from "../../services/Defaults";

export default {
    name: "Button",
    props: {
        cls: {
            type: String|Array,
            required: false,
        },
        href: {
            type: String,
            required: false,
        },
        type: {
            type: String,
            required: false,
            default: 'button'
        },
        text: {
            type: String,
            required: false,
        },
        hideTextInMobile: {
            type: Boolean,
            required: false,
            default: false
        },
        icon: {
            type: String|Array,
            required: false,
        },
        iconPosition: {
            type: String,
            required: false,
            default: 'left'
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        loading: {
            type: Boolean,
            required: false,
            default: false
        },
        targetWindow: {
            type: String,
            required: false,
            default: '_self'
        },
        downloadAttribute: {
            required: false,
            default: false
        },
        help: {
            type: String,
            required: false,
        }
    },

    computed: {
        computedId() {
            return slugify(this.text ?? 'custom');
        },
    },
    methods: {
        initTooltip() {
            if(this.help) {
                setTimeout(() => {
                    const tooltipTriggerList = [].slice.call(document.querySelectorAll(`#buttonId${this.computedId} [data-bs-toggle="tooltip"]`));
                    tooltipTriggerList.map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));
                }, 300);
            }

        },
    },
    mounted() {
        this.initTooltip();
    }
}
</script>

<template>
    <button v-if="!href" :class="['align-items-center btn', cls ?? '', {'btn-icon-split': icon && text}]"
            :id="'buttonId' + computedId"
            :type="type" :disabled="disabled || loading" @click="$emit('click', $event)">
        <slot>
            <div v-if="loading && iconPosition === 'left'" class="spinner-border spinner-border-sm"
                 role="status">
                <span class="sr-only"></span>
            </div>
            <i v-else-if="icon && iconPosition === 'left'" class="icon" :class="icon"></i>
            <span :class="['text', {'d-none d-md-block' : hideTextInMobile}]" v-if="text">{{ text }}</span>
            <div v-if="loading && iconPosition === 'right'" class="spinner-border spinner-border-sm"
                 role="status">
                <span class="sr-only"></span>
            </div>
            <i v-else-if="icon && iconPosition === 'right'" class="icon" :class="icon"></i>

            <div class="right-icon" v-if="help" data-bs-toggle="tooltip" data-bs-placement="top" :title="help">
                <i class="fi fi-rr-interrogation"></i>
            </div>
        </slot>
    </button>
    <a v-else :target="targetWindow" :href="href" :download="downloadAttribute"
       :id="'buttonId' + computedId"
       :class="['align-items-center btn', cls ?? '', {'btn-icon-split': icon && text}]" :type="type"
       :disabled="disabled || loading" @click="$emit('click', $event)">
        <slot>
            <div v-if="loading && icon && iconPosition === 'left'" class="spinner-border spinner-border-sm"
                 role="status">
                <span class="sr-only"></span>
            </div>
            <i v-else-if="icon && iconPosition === 'left'" class="icon" :class="icon"></i>
            <span :class="['text', {'d-none d-md-block' : hideTextInMobile}]" v-if="text">{{ text }}</span>
            <div v-if="loading && icon && iconPosition === 'right'" class="spinner-border spinner-border-sm"
                 role="status">
                <span class="sr-only"></span>
            </div>
            <i v-else-if="icon && iconPosition === 'right'" class="icon" :class="icon"></i>

            <div class="right-icon" v-if="help" data-bs-toggle="tooltip" data-bs-placement="top" :title="help">
                <i class="fi fi-rr-interrogation"></i>
            </div>
        </slot>
    </a>
</template>
